import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
//import "./../css/app.css";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import CircleBar from "./circlebar";
import Flapdisplay from "./flapdisplay";
import Normal from "./normal";
import Gauge from "./gauge";
import Gaugewithtwoaxes from "./gaugewithtwoaxes";
import Led from "./led";
import LinearGauge from "./linear-gauge";
import MultiGauge from "./multi_guage";
import Table from "./table";

const View = (props) => {
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  let targettopic;
  let wait_htd_timeout = 4000;
  const [state, setState] = useStateIfMounted({
    How_to_display_json: "",
  });
  let categoryid = "Htd " + props.viewId.replace("_", " ");

  function requestdata(datatype) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      datatype
    );
    mqtt_topics.busy_Requesting_Data = false;
    targettopic = mqtt_topics.fixed_topic_part + mac + "/" + datatype;
    props.mqttClient.subscribe(targettopic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == targettopic) {
      try {
        // message is Buffer
        //console.log("Topic:" + topic, "Message" + message.toString());
        message = JSON.parse(message.toString());
        setState({
          How_to_display_json: message,
        });
        //console.log("val:" + state.How_to_display_json);
      } catch (error) {
        //console.log(message);
      }
    }
  }

  function processHowToDisplay(htd) {
    let items = [];
    if (htd != "") {
      try {
        /*let common_display_type = "";
        let common_unit = "";
        /try {
          common_display_type = htd.display_type;
        } catch (error) {
          common_display_type = "";
        }
        try {
          common_unit = htd.unit;
        } catch (error) {
          common_unit = "";
        }*/
        let common_display_type = htd.display_type;
        let common_unit = htd.unit;
        let min = htd.min;
        let max = htd.max;

        for (let index = 0; index < htd.elements_array.length; index++) {
          let title = htd.elements_array[index].name;
          /*let display =
            common_display_type == undefined
              ? htd.elements_array[index].display_type
              : common_display_type;*/
          let display =
            htd.elements_array[index].display_type != undefined
              ? htd.elements_array[index].display_type
              : common_display_type;
          /*let unittodisplay =
            common_unit == undefined
              ? htd.elements_array[index].unit
              : common_unit;
          unittodisplay = unittodisplay == undefined ? "" : unittodisplay;*/
          let unittodisplay =
            htd.elements_array[index].unit != undefined
              ? htd.elements_array[index].unit
              : common_unit;
          unittodisplay = unittodisplay == undefined ? "" : unittodisplay;
          let choosenmin =
            htd.elements_array[index].min == undefined
              ? min == undefined
                ? 0
                : min
              : htd.elements_array[index].min;
          let chossenmax =
            htd.elements_array[index].max == undefined
              ? max == undefined
                ? 100
                : max
              : htd.elements_array[index].max;
          switch (display.toLowerCase()) {
            case "normal":
              {
                items.push(
                  <Normal
                    key={props.viewId + "_" + title}
                    title={title}
                    startedToListen={false}
                    unit={unittodisplay}
                    category={props.viewId.replace("_", " ")}
                    mqttClient={props.mqttClient}
                  />
                );
              }
              break;
            case "circlebar":
              {
                items.push(
                  <CircleBar
                    key={props.viewId + "_" + title}
                    title={title}
                    unit={unittodisplay}
                    category={props.viewId.replace("_", " ")}
                    max={chossenmax}
                    min={choosenmin}
                    mqttClient={props.mqttClient}
                  />
                );
              }
              break;
            case "flapdisplay":
              {
                items.push(
                  <Flapdisplay
                    key={props.viewId + "_" + title}
                    title={title}
                    unit={unittodisplay}
                    mqttClient={props.mqttClient}
                    category={props.viewId.replace("_", " ")}
                    background={htd.elements_array[index].background}
                  />
                );
              }
              break;
            case "guagewithtwoaxes":
              {
                items.push(
                  <Gaugewithtwoaxes
                    key={props.viewId + "_" + title}
                    title={title}
                    unit={unittodisplay}
                    secondunit={htd.elements_array[index].unit2}
                    coefficient={
                      htd.elements_array[index].conversion_coefficient
                    }
                    category={props.viewId.replace("_", " ")}
                    max={chossenmax}
                    min={choosenmin}
                    mqttClient={props.mqttClient}
                  />
                );
              }
              break;
            case "led":
              {
                items.push(
                  <Led
                    key={props.viewId + "_" + title}
                    title={title}
                    unit={unittodisplay}
                    mqttClient={props.mqttClient}
                    category={props.viewId.replace("_", " ")}
                  />
                );
              }
              break;
            case "linear-gauge":
              {
                items.push(
                  <LinearGauge
                    key={props.viewId + "_" + title}
                    title={title}
                    unit={unittodisplay}
                    max={chossenmax}
                    min={choosenmin}
                    mqttClient={props.mqttClient}
                    category={props.viewId.replace("_", " ")}
                  />
                );
              }
              break;
            case "multigauge":
              {
                items.push(
                  <MultiGauge
                    key={props.viewId + "_" + title}
                    title={title}
                    unit={unittodisplay}
                    max={chossenmax}
                    min={choosenmin}
                    category={props.viewId.replace("_", " ")}
                    names={htd.elements_array[index].names}
                    mqttClient={props.mqttClient}
                  />
                );
              }
              break;
            case "gauge":
              {
                items.push(
                  <Gauge
                    key={props.viewId + "_" + title}
                    title={title}
                    unit={unittodisplay}
                    max={chossenmax}
                    min={choosenmin}
                    category={props.viewId.replace("_", " ")}
                    mqttClient={props.mqttClient}
                  />
                );
              }
              break;
            case "table":
              {
                items.push(
                  <Table
                    key={props.viewId + "_" + title}
                    htd={htd}
                    title={title}
                    startedToListen={false}
                    category={props.viewId.replace("_", " ")}
                    mqttClient={props.mqttClient}
                  />
                );
              }
              break;
            default:
              {
                items.push(
                  <div className="col">
                    <center>
                      <p>
                        <strong>Unhandled display type :(</strong>
                        <br />
                      </p>
                    </center>
                  </div>
                );
              }
              break;
          }
        }
      } catch (Exception) {
        //console.log("Exception  " + Exception);
        items = [];
        items.push(
          <div className="col">
            <center>
              <p>
                <strong>Failed to render display :(</strong>
                <br />
              </p>
            </center>
          </div>
        );
      }
    } else {
      items = [];
      items.push(
        <div className="col">
          <center>
            <p>
              <strong>Failed to render display :(</strong>
              <br />
            </p>
          </center>
        </div>
      );
    }
    return items;
  }

  function getData() {
    if (state.How_to_display_json == "") {
      if (!mqtt_topics.busy_Requesting_Data) {
        requestdata(categoryid);
      } else {
        setTimeout(function () {
          requestdata(categoryid);
        }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
      }
    }
  }

  useEffect(() => {
    getData();

    //check after period if htd is received well
    setTimeout(function () {
      getData();
    }, wait_htd_timeout);
  }, []); //state.How_to_display_json

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(
        mqtt_topics.fixed_topic_part + mac + "/" + categoryid
      );
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  //<hr className="hr" />
  //id={list.replace(" ", "_") + "_Loading"}
  if (state.How_to_display_json == "") {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading {props.viewId.replace("_", " ")} ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return processHowToDisplay(state.How_to_display_json);
  }
};
export default View;
